export enum SchemasTarget {
  forEveryone = 'forEveryone',
  forAffiliates = 'forAffiliates',
  forAdvertisers = 'forAdvertisers',
}
